const inputFilesCustom = {
    init($parent: HTMLElement|Document = document) : void {
        const $inputFileCustomItems = $parent.querySelectorAll<HTMLInputElement>('.js-input-file-custom');

        $inputFileCustomItems.forEach($element => {
            const $inputFile = $element.querySelector<HTMLInputElement>('input[type="file"]');
            const $fileDelete = $element.querySelector<HTMLButtonElement>('.js-file-delete');

            if ($inputFile) {
                $inputFile.addEventListener('change', evt => {
                    const $targetEl = evt.target as HTMLInputElement;

                    if ($inputFile.value && this.checkFileSize($targetEl) && $targetEl.files?.length) {
                        const file = $targetEl.files[0];
                        this.showFileName($element, file);
                    } else {
                        this.clearFile($element);
                    }
                });
            }

            if ($fileDelete) {
                $fileDelete.addEventListener('click', () => {
                    this.clearFile($element);
                });
            }
        });

        // Initialisation des champs ajoutés dynamiquement via un champ Collection (cf. collection-field.ts)
        document.addEventListener('collectionFieldItemAdded', evt => {
            this.init(evt.detail.$item);
        });
    },

    showFileName($element: HTMLElement, file: File) : void {
        const $fileName = $element.querySelector<HTMLElement>('.js-file-name');
        const $fileType = $element.querySelector<HTMLElement>('.js-file-type');
        const $fileDelete = $element.querySelector<HTMLButtonElement>('.js-file-delete');

        if ($fileName && $fileType && $fileDelete) {
            $fileName.innerText = file.name;
            $fileType.classList.add('hidden');
            $fileDelete.classList.remove('hidden');
        }
    },

    clearFile($element: HTMLElement) : void {
        const $inputFile = $element.querySelector<HTMLInputElement>('input[type="file"]');
        const $fileName = $element.querySelector<HTMLElement>('.js-file-name');
        const $fileType = $element.querySelector<HTMLElement>('.js-file-type');
        const $fileDelete = $element.querySelector<HTMLButtonElement>('.js-file-delete');

        if ($inputFile) {
            $inputFile.value = '';
            $inputFile.dispatchEvent(new Event('cancel'));
        }

        if ($fileName && $fileType && $fileDelete) {
            $fileName.innerText = $fileName.dataset.initialText as string;
            $fileType.classList.remove('hidden');
            $fileDelete.classList.add('hidden');
        }
    },

    checkFileSize($inputFile: HTMLInputElement) : boolean {
        const maxSizeInMB = parseFloat($inputFile.dataset.maxSize as string);

        if ($inputFile.files?.length) {
            const filesize = parseFloat((($inputFile.files[0].size / 1024) / 1024).toFixed(4)); // MB
            return filesize <= maxSizeInMB;
        }

        return false;
    },
};

export default inputFilesCustom;
